import {
  AbstractControl,
  FormArray,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

/**
 * Validator that ensures a FormArray becomes INVALID if any of its children are INVALID.
 * This propagates child validation status to the FormArray level.
 *
 * Use case: When you need the parent form to reflect the validity of child controls
 * Example: FormArrays for contacts and documents that must all be valid
 */
export function formArrayChildrenValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!(control instanceof FormArray)) {
      return null;
    }

    // Check if any child control is invalid
    const hasInvalidChild = control.controls.some((child) => child.invalid);

    if (hasInvalidChild) {
      return { invalidChildren: true };
    }

    return null;
  };
}
